import { useQuery } from 'react-query';
import { GupshupTemplateResponse } from '@bandido/shared/types';
import { client } from '@frontend/features/common/services';
import { QueryKeys } from '@frontend/features/common/types';

const fetchTemplates = async (agencyId: number): Promise<GupshupTemplateResponse> => {
  const { data } = await client.get(`/whatsapp/templates/${agencyId}`); // asumimos un proxy backend
  return data;
};

export const useGetTemplates = (agencyId?: number) =>
  useQuery([QueryKeys.gupshupTemplates, agencyId], () => fetchTemplates(agencyId as number), {
    enabled: Boolean(agencyId)
  });
